import { Container } from "@sainsburys-tech/luna-grid"
import { Display3 } from "@sainsburys-tech/luna-typography"
import Drafts from "../components/Drafts/Drafts"
import ReportIncident from "../components/ReportIncident"
import { useNavigate } from "react-router"

const DraftsPage = () => {

  const navigateTo = useNavigate()

  const createReport = async() => {
    navigateTo("/reporting")
  }

  return (
    <div className="s-drafts-dashboard ln-u-1/1">
      <ReportIncident onClick={createReport}/>
        
      <Container className="ln-u-padding-bottom*4" size="xs">
        <div>
          <Display3 id="s-page-title" className="s-page-title ln-u-padding-left*2">
            My drafts
          </Display3>
        </div>
      </Container>

      <Container className="s-drafts" size="xs">
        <Drafts />
      </Container>
    </div>
  )
}

export default DraftsPage